import store from '@/store';
export default async function externalComponent(route, name) {
    if (window[name]) return window[name];

    const baseUrl = `${store.getters['account/apiUrl']}/api`;
    const token = store.getters['account/token'];
    const url = `${baseUrl}/${route}`;
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/javascript',
        },
    });
    if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
    }

    const scriptContent = await response.text();
    const blob = new Blob([scriptContent], { type: 'application/javascript' });
    const blobUrl = URL.createObjectURL(blob);

    window[name] = await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = blobUrl;
        script.async = true;
        script.addEventListener('load', () => {
            resolve(window[name]);
            URL.revokeObjectURL(blobUrl);
        });
        script.addEventListener('error', () => {
            reject(new Error(`Error loading ${url}`));
        });
        document.head.appendChild(script);
    });

    return window[name];
}